import React from 'react';
import { IntegrationHistory } from '@pages-clean/admin/org/manage-cm-integration/integration-history/integration-history';
import { LoggedInPageProps } from '@config/routes/interfaces';

export const ManageCmIntegration = ({ user }: LoggedInPageProps) => {
    return <IntegrationHistory user={user} />;
};
